export default __webpack_public_path__ + "a8d2c960daaf9aed9768aaba30e94fd0.svg";